import React, { useState, useCallback, useEffect } from 'react';
import ComboboxComFiltro from '../../components/autocomplete';

import {
  Container,
  GroupBoxUsuario,
  GroupBoxLegenda,
  InputNome,
  InputEmail,
  InputSenha,
  BotoesContainer,
  BotaoLimpar,
  BotaoSalvar,
  InputNomePesquisa,
  InputEmailPesquisa,
  ContainerPesquisa,
  CardPesquisa,
  Botao,
  ContainerButton,
  ContainerTabs,
  TabButton,
  ContainerHorario,
  CardHorario,
  BotaoHorario,
  CustomCheckBox,
  InputValorHora,
} from './styles';

import IPerfis from '../../routes/vms/IPerfis';
import IUsuario from '../../routes/vms/IUsuario';

import api from '../../services/api';
import { useToast } from '../../context/ToastContext';
import { useAuth } from '../../context/AuthContext';
import { useConfigs } from '../../context/ConfigsContext';
import {
  FiSave,
  FiTrash2,
  FiRefreshCw,
  FiCheckCircle,
  FiUserPlus,
  FiFilter,
  FiClock,
  FiPlus,
  FiTrash,
} from 'react-icons/fi';
import { returnAxiosError } from '../../utils/returnAxiosError';

interface ComboBox {
  id: string;
  nome: string;
}

interface UsuarioHorario {
  id?: string;
  user_id: string;
  hora_inicio: string;
  hora_fim: string;
  dia_semana: number;
}

const Usuario: React.FC = () => {
  const { addToast } = useToast();
  const { lerConfig } = useConfigs();
  const { user, verifyAccess } = useAuth();

  const [usuarios, setUsuarios] = useState<IUsuario[]>([]);
  const [usuariosPesquisados, setUsuariosPesquisados] = useState<IUsuario[]>(
    [],
  );
  const [perfis, setPerfis] = useState<ComboBox[]>([]);
  const [diasSemana, setDiasSemana] = useState<ComboBox[]>([]);
  const [horarios, setHorarios] = useState<ComboBox[]>([]);
  const [usuarioHorarios, setUsuarioHorarios] = useState<UsuarioHorario[]>([]);

  //Campos obrigatórios
  const [email, setEmail] = useState<string>('');
  const [emailErro, setEmailErro] = useState<string>('');
  const [nome, setNome] = useState<string>('');
  const [nomeErro, setNomeErro] = useState<string>('');
  const [senha, setSenha] = useState<string>('');
  const [senhaErro, setSenhaErro] = useState<string>('');
  const [perfil, setPerfil] = useState<string | null>(null);
  const [perfilErro, setPerfilErro] = useState<string>('');
  const [valorHora, setValorHora] = useState<number>(0);

  const [profissional, setProfissional] = useState(false);

  const [dia, setDia] = useState<string | null>(null);
  const [diaErro, setDiaErro] = useState('');
  const [horaIni, setHoraIni] = useState<string | null>(null);
  const [horaIniErro, setHoraIniErro] = useState('');
  const [horaFim, setHoraFim] = useState<string | null>(null);
  const [horaFimErro, setHoraFimErro] = useState('');

  //Campos pesquisa
  const [nomePesquisa, setNomePesquisa] = useState<string>('');
  const [emailPesquisa, setEmailPesquisa] = useState<string>('');
  const [perfilPesquisa, setPerfilPesquisa] = useState<string | null>(null);

  const [usuarioSelecionado, setUsuarioSelecionado] = useState<
    IUsuario | undefined
  >(undefined);
  const [tabSelecionada, setTabSelecionada] = useState('Cadastro');
  const [visibilidadeHorarios, setVisibilidadeHorarios] = useState(false);

  const horariosAgrupados = usuarioHorarios.reduce(
    (acc, horario) => {
      const dia = horario.dia_semana;
      if (!acc[dia]) {
        acc[dia] = [];
      }
      acc[dia].push(horario);
      return acc;
    },
    {} as Record<string, typeof usuarioHorarios>,
  );

  const aoAlterarEmail = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setEmail(event.target.value);
      setEmailErro('');
    },
    [],
  );

  const aoAlterarEmailPesquisa = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setEmailPesquisa(event.target.value);
    },
    [],
  );

  const aoAlterarNome = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setNome(event.target.value);
      setNomeErro('');
    },
    [],
  );

  const aoAlterarValorHora = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setValorHora(Number(event.target.value));
    },
    [],
  );

  const aoAlterarSenha = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSenha(event.target.value);
      setSenhaErro('');
    },
    [],
  );

  const padronizaHorario = useCallback((horario: string) => {
    if (horario.length === 5) {
      return horario;
    }

    const horarioFormatado = horario.slice(0, 5);

    return horarioFormatado;
  }, []);

  const retornaDiaExtenso = useCallback((diaNumero: number) => {
    const dias = [
      'DOMINGO',
      'SEGUNDA-FEIRA',
      'TERÇA-FEIRA',
      'QUARTA-FEIRA',
      'QUINTA-FEIRA',
      'SEXTA-FEIRA',
      'SÁBADO',
    ];

    return dias[diaNumero];
  }, []);

  const fetchDiasSemana = useCallback(async () => {
    const DiasQueNaoTrabalha = lerConfig('DIAS QUE NÃO TRABALHA');
    const diasNaoTrabalhaArray = DiasQueNaoTrabalha.replace(/\s+/g, '').split(
      ',',
    );

    const diasSemana = [
      { id: '0', nome: 'DOMINGO' },
      { id: '1', nome: 'SEGUNDA-FEIRA' },
      { id: '2', nome: 'TERÇA-FEIRA' },
      { id: '3', nome: 'QUARTA-FEIRA' },
      { id: '4', nome: 'QUINTA-FEIRA' },
      { id: '5', nome: 'SEXTA-FEIRA' },
      { id: '6', nome: 'SÁBADO' },
    ];

    setDiasSemana(
      diasSemana.filter(dia => !diasNaoTrabalhaArray.includes(dia.id)),
    );
  }, [lerConfig]);

  const fetchHorarios = useCallback(async () => {
    const horariosArray = await api.get<{ horarios: string[] }>(
      '/empresas/horarios/',
      {
        params: {
          url_frontend: user.empresa.url_frontend,
        },
      },
    );

    const horariosCombo: ComboBox[] = horariosArray.data.horarios.map(
      horario => ({
        id: horario,
        nome: horario,
      }),
    );

    setHorarios(horariosCombo);
  }, [user]);

  const atualizaDados = useCallback(async () => {
    try {
      const [usuariosResponse, perfisResponse] = await Promise.all([
        api.get<IUsuario[]>('/users/por-empresa', {
          params: { empresa_id: user.empresa_id },
        }),
        api.get<IPerfis[]>('/perfis/todos'),
      ]);

      const perfisFormatados: ComboBox[] = perfisResponse.data.map(perfil => ({
        id: perfil.id,
        nome: perfil.descricao,
      }));

      setUsuarios(usuariosResponse.data);
      setUsuariosPesquisados(usuariosResponse.data);
      setPerfis(perfisFormatados);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  }, [user]);

  const aoLimpar = useCallback((tipo: string) => {
    if (tipo === 'U' || tipo === 'T') {
      setNome('');
      setNomeErro('');
      setEmail('');
      setEmailErro('');
      setSenha('');
      setSenhaErro('');
      setPerfil(null);
      setValorHora(0);
      setPerfilErro('');
      setProfissional(false);

      setUsuarioSelecionado(undefined);
      setVisibilidadeHorarios(false);
      setUsuarioHorarios([]);
    }

    if (tipo === 'H' || tipo === 'T') {
      setDia(null);
      setDiaErro('');
      setHoraIni(null);
      setHoraIniErro('');
      setHoraFim(null);
      setHoraFimErro('');
    }
  }, []);

  const atualizarSenha = useCallback(async () => {
    if (!usuarioSelecionado) {
      addToast({
        type: 'error',
        title: 'Usuário',
        description: 'Nenhum usuário selecionado para alterar a senha',
      });
      return;
    }

    await api.patch(`/profile`, {
      user_id: usuarioSelecionado.id,
      senha: senha,
    });

    addToast({
      type: 'success',
      title: 'Parabéns',
      description: 'Senha alterada com sucesso!',
    });
  }, [addToast, usuarioSelecionado, senha]);

  const handleInativarUsuario = useCallback(
    async (email: string) => {
      await api.post(`/users/ativar`, { email });

      addToast({
        type: 'success',
        title: 'Parabéns',
        description: 'Usuário excluído com sucesso!',
      });

      atualizaDados();
      aoLimpar('T');
    },
    [addToast, atualizaDados, aoLimpar],
  );

  const validacoesHorarios = useCallback(() => {
    setDiaErro('');
    setHoraIniErro('');
    setHoraFimErro('');

    let erroValidacao = false;
    if (!usuarioSelecionado) {
      addToast({
        type: 'error',
        title: 'Pendências na validação',
        description: 'Nenhum usuário selecionado para incluir os horários.',
      });
      return false;
    }

    if (!dia) {
      setDiaErro('Informação Obrigatória!');
      erroValidacao = true;
    }
    if (!horaIni) {
      setHoraIniErro('Informação Obrigatória!');
      erroValidacao = true;
    }
    if (!horaFim) {
      setHoraFimErro('Informação Obrigatória!');
      erroValidacao = true;
    }

    if (erroValidacao) {
      addToast({
        type: 'info',
        title: 'Pendências na validação',
        description:
          'Efetue as correções indicadas em cada campo e tente novamente.',
      });
      return false;
    }
  }, [addToast, dia, horaFim, horaIni, usuarioSelecionado]);

  const validacoesUsuario = useCallback(() => {
    setNomeErro('');
    setEmailErro('');
    setSenhaErro('');
    setPerfilErro('');

    let erroValidacao = false;
    if (nome === '') {
      setNomeErro('Informação obrigatória!');
      erroValidacao = true;
    }
    if (email === '') {
      setEmailErro('Informação obrigatória!');
      erroValidacao = true;
    }
    if (senha === '') {
      setSenhaErro('Informação obrigatória!');
      erroValidacao = true;
    }
    if (!perfil) {
      setPerfilErro('Informação obrigatória!');
      erroValidacao = true;
    }

    if (erroValidacao) {
      addToast({
        type: 'info',
        title: 'Pendências na validação',
        description:
          'Efetue as correções indicadas em cada campo e tente novamente.',
      });
      return false;
    }
  }, [addToast, nome, perfil, email, senha]);

  const atualizaHorarios = useCallback(async (usuario_id: string) => {
    try {
      const request = await api.get<UsuarioHorario[]>(
        `/users-horarios/${usuario_id}`,
      );

      setUsuarioHorarios(request.data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const aoSalvarHorario = useCallback(async () => {
    if (validacoesHorarios() === false) {
      return;
    }

    const horarioGravar: UsuarioHorario = {
      user_id: usuarioSelecionado ? usuarioSelecionado.id : '',
      dia_semana: Number(dia),
      hora_inicio: horaIni ? horaIni : '',
      hora_fim: horaFim ? horaFim : '',
    };

    try {
      await api.post('/users-horarios', horarioGravar);

      addToast({
        type: 'success',
        title: 'Horário salvo com sucesso!!!',
      });
    } catch (error) {
      addToast(returnAxiosError(error));

      return;
    }

    atualizaHorarios(usuarioSelecionado ? usuarioSelecionado.id : '');
    aoLimpar('H');
  }, [
    atualizaHorarios,
    addToast,
    aoLimpar,
    dia,
    horaFim,
    horaIni,
    usuarioSelecionado,
    validacoesHorarios,
  ]);

  const aoSalvar = useCallback(async () => {
    if (validacoesUsuario() === false) {
      return;
    }

    const usuarioGravar: Omit<IUsuario, 'id'> = {
      name: nome.toUpperCase(),
      email,
      password: senha,
      empresa_id: user.empresa_id,
      profissional: profissional,
      perfil_id: perfil ? perfil : '',
      vr_hora: valorHora,
    };

    try {
      if (usuarioSelecionado) {
        await api.patch(`/users/perfil/${usuarioSelecionado.id}`, {
          perfil_id: perfil,
          profissional: String(profissional),
          vr_hora: valorHora,
        });
      } else {
        await api.post('users', usuarioGravar);
      }

      addToast({
        type: 'success',
        title: 'Usuário salvo com sucesso!!!',
      });
    } catch (error) {
      addToast(returnAxiosError(error));

      return;
    }

    aoLimpar('T');
    atualizaDados();
  }, [
    addToast,
    email,
    nome,
    perfil,
    senha,
    profissional,
    user.empresa_id,
    usuarioSelecionado,
    valorHora,
    validacoesUsuario,
    aoLimpar,
    atualizaDados,
  ]);

  const aoSelecionarUsuario = useCallback(
    async (usuario: IUsuario) => {
      setUsuarioSelecionado(usuario);
      setVisibilidadeHorarios(usuario.profissional);

      setNome(usuario.name);
      setEmail(usuario.email);
      setSenha('senha exemplo');
      setPerfil(usuario.perfil_id);
      setProfissional(usuario.profissional);
      setValorHora(usuario.vr_hora);

      atualizaHorarios(usuario.id);

      setTabSelecionada('Cadastro');
    },
    [atualizaHorarios],
  );

  const aoAlterarNomePesquisa = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setNomePesquisa(event.target.value);
    },
    [],
  );

  const aoAlterarPerfil = (perfil: string | null) => {
    setPerfil(perfil);
    setPerfilErro('');
  };

  const aoAlterarDia = (dia: string | null) => {
    setDia(dia);
    setDiaErro('');
  };

  const aoAlterarHoraIni = (horaIni: string | null) => {
    setHoraIni(horaIni);
    setHoraIniErro('');
  };

  const aoAlterarHoraFim = (horaFim: string | null) => {
    setHoraFim(horaFim);
    setHoraFimErro('');
  };

  const aoAlterarPerfilPesquisa = (responsavel: string | null) => {
    setPerfilPesquisa(responsavel);
  };

  const handleExcluirHorario = useCallback(
    async (horario_id: string) => {
      await api.delete(`/users-horarios/${horario_id}`);

      setTimeout(
        () => atualizaHorarios(usuarioSelecionado ? usuarioSelecionado.id : ''),
        2000,
      );
    },
    [atualizaHorarios, usuarioSelecionado],
  );

  useEffect(() => {
    let listaFiltrar = usuarios;

    if (nomePesquisa !== '') {
      listaFiltrar = listaFiltrar?.filter(user =>
        user.name.toUpperCase().includes(nomePesquisa.toUpperCase()),
      );
    }

    if (emailPesquisa !== '') {
      listaFiltrar = listaFiltrar?.filter(user =>
        user.email.includes(emailPesquisa),
      );
    }

    if (perfilPesquisa) {
      listaFiltrar = listaFiltrar?.filter(
        user => user.perfil_id === perfilPesquisa,
      );
    }

    setUsuariosPesquisados(listaFiltrar);
  }, [emailPesquisa, nomePesquisa, usuarios, perfilPesquisa, perfis]);

  useEffect(() => {
    atualizaDados();
  }, [atualizaDados]);

  useEffect(() => {
    fetchDiasSemana();
  }, [fetchDiasSemana]);

  useEffect(() => {
    fetchHorarios();
  }, [fetchHorarios]);

  useEffect(() => {
    aoLimpar('T');
  }, [aoLimpar]);

  return (
    <Container>
      <ContainerTabs>
        <TabButton
          onClick={() => {
            setTabSelecionada('Cadastro');
          }}
          ativa={tabSelecionada === 'Cadastro'}
        >
          <FiUserPlus />
        </TabButton>
        {visibilidadeHorarios && (
          <TabButton
            onClick={() => {
              setTabSelecionada('Horarios');
            }}
            ativa={tabSelecionada === 'Horarios'}
          >
            <FiClock />
          </TabButton>
        )}
        <TabButton
          onClick={() => {
            setTabSelecionada('Pesquisa');
          }}
          ativa={tabSelecionada === 'Pesquisa'}
        >
          <FiFilter />
        </TabButton>
      </ContainerTabs>

      {tabSelecionada === 'Cadastro' && (
        <GroupBoxUsuario>
          <GroupBoxLegenda>Usuário</GroupBoxLegenda>

          <span>
            <InputNome
              variant="outlined"
              margin="normal"
              id="nome"
              label="Nome"
              name="nome"
              value={nome}
              onChange={aoAlterarNome}
              error={nomeErro !== ''}
              helperText={nomeErro}
              disabled={!!usuarioSelecionado}
            />

            <InputEmail
              variant="outlined"
              margin="normal"
              id="email"
              label="Email"
              name="email"
              value={email}
              onChange={aoAlterarEmail}
              error={emailErro !== ''}
              helperText={emailErro}
              disabled={!!usuarioSelecionado}
            />

            <ContainerButton>
              <InputSenha
                variant="outlined"
                margin="normal"
                id="senha"
                label="Senha"
                name="senha"
                type="password"
                value={senha}
                onChange={aoAlterarSenha}
                error={senhaErro !== ''}
                helperText={senhaErro}
              />

              <Botao
                title="Salvar cadastro"
                onClick={() => {
                  atualizarSenha();
                }}
              >
                <FiCheckCircle />
              </Botao>
            </ContainerButton>
          </span>

          <span>
            <ComboboxComFiltro
              opcoes={perfis}
              value={perfil}
              label="Perfil"
              onChange={aoAlterarPerfil}
              error={perfilErro !== ''}
              helperText={perfilErro}
              temMargin={true}
              size={3}
            />

            {verifyAccess('VISUALIZAR CAMPO VALOR HORA CADASTRO USUÁRIO') && (
              <InputValorHora
                variant="outlined"
                margin="normal"
                type="number"
                id="valorHora"
                label="Valor Hora"
                name="valorHora"
                value={valorHora}
                onChange={aoAlterarValorHora}
              />
            )}

            <CustomCheckBox>
              <input
                type="checkbox"
                checked={profissional}
                onChange={() => {
                  setProfissional(!profissional);
                }}
              />
              Profissional
            </CustomCheckBox>
          </span>

          <BotoesContainer>
            <BotaoSalvar onClick={aoSalvar}>
              <FiSave />
              Salvar
            </BotaoSalvar>

            <BotaoLimpar onClick={() => aoLimpar('T')}>
              <FiRefreshCw />
              Limpar
            </BotaoLimpar>
          </BotoesContainer>
        </GroupBoxUsuario>
      )}

      {tabSelecionada === 'Horarios' && (
        <GroupBoxUsuario>
          <GroupBoxLegenda>{`Usuário - ${usuarioSelecionado?.name}`}</GroupBoxLegenda>
          <span>
            <ComboboxComFiltro
              opcoes={diasSemana}
              value={dia}
              label="Dia da Semana"
              onChange={aoAlterarDia}
              error={diaErro !== ''}
              helperText={diaErro}
              temMargin
              size={2}
            />

            <ComboboxComFiltro
              opcoes={horarios}
              value={horaIni}
              label="Hora Início"
              onChange={aoAlterarHoraIni}
              error={horaIniErro !== ''}
              helperText={horaIniErro}
              temMargin
              size={1}
            />

            <ComboboxComFiltro
              opcoes={horarios}
              value={horaFim}
              label="Hora Fim"
              onChange={aoAlterarHoraFim}
              error={horaFimErro !== ''}
              helperText={horaFimErro}
              temMargin
              size={1}
            />

            <BotaoHorario
              title="Incluir Horário"
              onClick={() => {
                aoSalvarHorario();
              }}
            >
              <FiPlus />
            </BotaoHorario>
          </span>

          <ContainerHorario>
            {Object.entries(horariosAgrupados).map(([dia, horarios]) => (
              <div key={dia}>
                <h3>{retornaDiaExtenso(Number(dia))}</h3>
                {horarios.map(horario => (
                  <CardHorario key={horario.id}>
                    <div>
                      <p>
                        <span>INÍCIO:</span>
                        {padronizaHorario(horario.hora_inicio)}
                      </p>
                      <p>
                        <span>FINAL:</span> {padronizaHorario(horario.hora_fim)}
                      </p>
                      <FiTrash
                        onClick={() =>
                          handleExcluirHorario(horario.id ? horario.id : '')
                        }
                      />
                    </div>
                  </CardHorario>
                ))}
              </div>
            ))}
          </ContainerHorario>
        </GroupBoxUsuario>
      )}

      {tabSelecionada === 'Pesquisa' && (
        <GroupBoxUsuario>
          <GroupBoxLegenda>Pesquisa</GroupBoxLegenda>

          <span>
            <InputNomePesquisa
              variant="outlined"
              margin="normal"
              id="nomePesq"
              label="Nome"
              name="nomePesq"
              value={nomePesquisa}
              onChange={aoAlterarNomePesquisa}
            />

            <InputEmailPesquisa
              variant="outlined"
              margin="normal"
              id="emailPesq"
              label="Email"
              name="emailPesq"
              value={emailPesquisa}
              onChange={aoAlterarEmailPesquisa}
            />

            <ComboboxComFiltro
              opcoes={perfis}
              value={perfilPesquisa}
              label="Perfil"
              onChange={aoAlterarPerfilPesquisa}
            />
          </span>

          <ContainerPesquisa>
            {usuariosPesquisados.map(usuario => (
              <CardPesquisa
                key={usuario.id}
                onClick={() => {
                  aoSelecionarUsuario(usuario);
                }}
              >
                <div>
                  <p>{usuario.name}</p>
                  <p>{usuario.email}</p>
                </div>
                <div>
                  <FiTrash2
                    onClick={() => {
                      handleInativarUsuario(usuario.email);
                    }}
                  />
                </div>
              </CardPesquisa>
            ))}
          </ContainerPesquisa>
        </GroupBoxUsuario>
      )}
    </Container>
  );
};

export default Usuario;
